// extracted by mini-css-extract-plugin
module.exports = {"pageCard":"Template_pageCard__3itde","templateImg":"Template_templateImg__2A3rP","textInfo":"Template_textInfo__Wj19R"};